if (!customElements.get('bundle-selector')) {
  class BundleSelector extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.onRadioChange.bind(this));

      const checked = this.querySelector('.bundle-selector__radio:checked');
      if (checked) this.applySelection(checked, false);
    }

    onRadioChange(event) {
      const target = event.target;
      if (!target || !target.classList.contains('bundle-selector__radio')) return;
      this.applySelection(target, true);
    }

    applySelection(radio, syncForm) {
      this.querySelectorAll('.bundle-selector__card').forEach((card) => {
        card.classList.remove('is-selected');
      });
      const card = radio.nextElementSibling;
      if (card) card.classList.add('is-selected');

      if (syncForm) this.syncQuantity(radio);
    }

    syncQuantity(radio) {
      const qty = parseInt(radio.value, 10);
      if (Number.isNaN(qty) || qty < 1) return;

      const form = this.resolveTargetForm();
      if (!form) return;

      const qtyInput =
        form.elements.namedItem('quantity') ||
        form.querySelector('input[name="quantity"]') ||
        document.querySelector(`input[name="quantity"][form="${form.id}"]`);
      if (!qtyInput) return;

      qtyInput.value = qty;
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    resolveTargetForm() {
      const id = this.dataset.formId;
      if (id) {
        const form = document.getElementById(id);
        if (form) return form;
      }
      return document.querySelector('form[data-type="add-to-cart-form"]');
    }
  }

  customElements.define('bundle-selector', BundleSelector);
}
